import { render, staticRenderFns } from "./author-list.vue?vue&type=template&id=9eea608c&scoped=true&"
import script from "./author-list.vue?vue&type=script&lang=js&"
export * from "./author-list.vue?vue&type=script&lang=js&"
import style0 from "./author-list.vue?vue&type=style&index=0&id=9eea608c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eea608c",
  null
  
)

export default component.exports